// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__wA6f-","head":"ProcedureTableInfo_head__2VQuO"};